import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IPrnEntry } from "../pages/master/models/prnModel";
import { BASE_URL, END_POINTS } from "../utility/APIConstants";
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export default class PRNService {
    constructor(private _http: HttpClient) { }
    public selectedPRNEntry: any = null;
    public fetchPRNEntries(): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.PRN_ENTRY.FETCH);
    }

    getPRNByPageCount(params = {}): Observable<any> {
        return this._http.get<any>(`${environment.apiBase}/prnentry/get-by-pagination`, { params });
    }

    public getPrnCount(branchKey?: number): Observable<any> {
        let url = `${environment.apiBase}/prnentry/count-prn-entries`;
        if (branchKey !== undefined && branchKey !== null) {
            url += `?branchKey=${branchKey}`;
        }
        return this._http.get<any>(url);
    }

    public createPRNEntry(payload: IPrnEntry): Observable<any> {
        return this._http.post(BASE_URL + END_POINTS.PRN_ENTRY.CREATE, payload);
    }
    public updatePRNEntry(payload: IPrnEntry): Observable<any> {
        return this._http.put(BASE_URL + END_POINTS.PRN_ENTRY.UPDATE(payload.prnKey), payload);
    }

    public approvePrn(id: any): Observable<any> {
        return this._http.put(BASE_URL + END_POINTS.PRN_ENTRY.APPROVE(id), {});
    }

    public rejectPrn(id: any, payload): Observable<any> {
        return this._http.put(BASE_URL + END_POINTS.PRN_ENTRY.REJECT(id), payload);
    }

    public deletePrn(id: any): Observable<any> {
        return this._http.put(BASE_URL + END_POINTS.PRN_ENTRY.DELETE(id), {});
    }

    public fetchPRNBySiteKey(id): Observable<any> {
        return this._http.get<any>(BASE_URL + END_POINTS.PRN_ENTRY.FETCH_BY_SITEKEY(id));
    }

    public fetchPRNBySiteKeyForPO(id): Observable<any> {
        return this._http.get<any>(BASE_URL + END_POINTS.PRN_ENTRY.FETCH_BY_SITEKEY_FOR_PO(id));
    }
    public fetchPRNById(id): Observable<any> {
        return this._http.get<any>(BASE_URL + END_POINTS.PRN_ENTRY.FETCH_BY_ID(id));
    }
    public fetchProductCodesByPrnIds(params) {
        return this._http.get(BASE_URL + END_POINTS.PRN_ENTRY.FETCH_PRODUCT_CODE_BY_PRN_IDS + '?' + params);
    }

    public fetchProductCodesByPrnIdAll(params) {
        return this._http.get(BASE_URL + END_POINTS.PRN_ENTRY.FETCH_PRODUCT_CODE_BY_PRN_IDS_QE + '&' + params);
    }

    public printPrn(id) {
        return this._http.get(BASE_URL + END_POINTS.PRN_ENTRY.PRINT(id), { responseType: 'blob' });
    }

    public getPrintData(id: number): Observable<any> {
        return this._http.get<any>(BASE_URL + END_POINTS.PRN_ENTRY.GET_PRINT(id));
    }

    public fetchAllPRNBySiteKey(id): Observable<any> {
        return this._http.get<any>(BASE_URL + END_POINTS.PRN_ENTRY.FETCH_ALL_BY_SITEKEY(id));
    }


    public fetchApprovedPrnsForRejection(siteKey: any, productType: string = ''): Observable<any> {
        const params: any = { siteKey };
        if (productType) {
            params.productType = productType;
        }
        return this._http.get<any>(`${environment.apiBase}/prnentry/get-approved-for-rejection`, { params });
    }

    // Submit a full or partial rejection for one PRN.
    // payload: { prnKey, isFullRejection, commonRemark, draft, rejectedItems: [{ prnDetailsKey, rejectQty, reason, remarks }] }
    public rejectPrnItems(payload: any): Observable<any> {
        return this._http.put(`${environment.apiBase}/prnentry/reject-items`, payload);
    }

    public fetchRejectableSites(): Observable<any> {
        return this._http.get<any>(`${environment.apiBase}/prnentry/get-rejectable-sites`);
    }



    // UPLOAD DOCUMENT

    uploadFile(data: any, formData: any): Observable<any> {
        return this._http.post(BASE_URL + END_POINTS.UPLOAD_DOCUMENT.UPLOAD(data.id, data.module), formData);
    }

    fetchUploadFile(data: any): Observable<any> {
        return this._http.get(BASE_URL + END_POINTS.UPLOAD_DOCUMENT.GETUPLOADFILE(data.id, data.module));
    }

    public DOWNLOADFILE(module: any, fileName: any) {
        return this._http.get(BASE_URL + END_POINTS.UPLOAD_DOCUMENT.DOWNLOADFILE(module, fileName), { responseType: 'blob' });
    }

    public DELETEFILE(module: any, fileName: any) {
        return this._http.delete(BASE_URL + END_POINTS.UPLOAD_DOCUMENT.DELETEFILE(module, fileName));
    }

    updateUploadFile(data: any, FormData: any): Observable<any> {
        return this._http.put(BASE_URL + END_POINTS.UPLOAD_DOCUMENT.UPDATEFILE(data.id, data.fileName), FormData);
    }


    uploadToS3(
        formData: FormData,
        module: string,
        transactionId: number
    ) {

        formData.append('module', module);
        formData.append('transactionId', transactionId.toString());

        return this._http.post(
            environment.apiBase + '/documents/upload',
            formData,
            {
                responseType: 'text'
            }
        );
    }

    downloadFromS3(key: string) {
        return this._http.get(
            environment.apiBase +
            '/documents/download?key=' +
            encodeURIComponent(key),
            {
                responseType: 'blob'
            }
        );
    }

    downloadPreviewFromS3(key: string) {
        return this._http.get(
            environment.apiBase + '/documents/downloadPreview?key=' + encodeURIComponent(key),
            { responseType: 'blob' }
        );
    }

    fetchDocumentsByModule(module: string, transactionId: any): Observable<any> {
        return this._http.get(
            environment.apiBase +
            '/documents/list?module=' + encodeURIComponent(module) +
            '&transactionId=' + encodeURIComponent(transactionId)
        );
    }
}
